const AudioDivider = () => {
  return (
    <div className="flex flex-col items-center h-full px-4">
      <div className="w-px h-8 bg-lightgray opacity-50"></div>
      <div className="py-2 font-bold text-xl text-lightgray">or</div>
      <div className="w-px h-8 bg-lightgray opacity-50"></div>
    </div>
  );
};

export default AudioDivider;
